import { render, staticRenderFns } from "./productCategoryDialog.vue?vue&type=template&id=3371dd9c&scoped=true"
import script from "./productCategoryDialog.vue?vue&type=script&lang=js"
export * from "./productCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3371dd9c",
  null
  
)

export default component.exports